import { useState } from "react";
import { SparklesIcon } from "lucide-react";

import { GenerateRubricModal } from "./GenerateRubricModal";
import { Column, Text } from "@/components";
import { Button } from "@/components/ui/button";

import { JobInternalConfig as JobInternalConfigType } from "@/types";

export const PreRubricView = ({
  jobInternalConfig,
}: {
  jobInternalConfig: JobInternalConfigType;
}) => {
  /* React Hooks */
  // useState
  const [isGenerateOpen, setIsGenerateOpen] = useState(false);

  /* Render */
  const render = () => {
    return (
      <>
        <Column className="items-center gap-2 rounded-lg border border-dashed border-slate-200 p-6">
          <Text>
            Generate a rubric to enable automatic profile rating for this job!
          </Text>
          <Button
            onClick={() => {
              setIsGenerateOpen(true);
            }}
          >
            <SparklesIcon className="h-4 w-4" />
            Generate Rubric
          </Button>
        </Column>

        {isGenerateOpen && (
          <GenerateRubricModal
            isRegenerate={false}
            jobInternalConfig={jobInternalConfig}
            onClose={() => {
              setIsGenerateOpen(false);
            }}
          />
        )}
      </>
    );
  };

  return render();
};
